import React from "react";

const MentionLegal = () => {
  return (
    <section id="infogerance" className="service-details">
      <div className="container">
        <div className="row">
          <div className="column">
            <div className="service-details__content">
              <h3 className="service-details__title">Mentions Légales</h3>
              <p className="service-details__text">
                La connexion et la navigation sur le site par l’utilisateur implique
                acceptation intégrale et sans réserve des présentes mentions légales.
                <br />
                Ces dernières sont accessibles sur le site{" "}
                <strong>www.jppcompta.fr</strong> à la rubrique « Mentions légales ».
              </p>

              <Article
                title="1. Présentation du site"
                content={
                  <>
                    En vertu de l’article 6 de la loi n° 2004-575 du 21 juin 2004 pour la
                    confiance dans l’économie numérique, dite L.C.E.N., il est précisé aux
                    utilisateurs et visiteurs du site <strong>www.jppcompta.fr</strong>{" "}
                    l’identité des intervenants :
                    <ul>
                      <li>
                       SASU jppCompta, capital 1000€, RCS Nice (SIREN : 951504893), situé au
                        14 AVENUE GEORGES CLEMENCEAU, 06000 NICE.
                      </li>
                      <li>Responsable publication : M. Romain Guaresi</li>
                      <li>
                        Hébergeur :  SARL MaelCorp. , capital 1000 euros, 58 Corniche Fleurie, 06200, Nice  
                      </li>
                    </ul>
                  </>
                }
              />

              <Article
                title="2. Informations nominatives"
                content={
                  <>
                    Conformément à la réglementation, vous disposez d’un droit d’opposition,
                    d’accès et de rectification. Ces droits peuvent être exercés via{" "}
                    <a href="/">cette page</a> ou par courrier postal.
                  </>
                }
              />

              <Article
                title="3. Conditions générales d’utilisation"
                content={
                  <>
                    L’utilisation du site <strong>www.jppcompta.fr</strong> implique
                    l’acceptation pleine et entière des conditions générales d’utilisation.
                    Ces conditions peuvent être modifiées à tout moment, les utilisateurs
                    sont invités à les consulter régulièrement.
                  </>
                }
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const Article = ({ title, content }) => (
  <div className="article">
    <h4 className="article__title">{title}</h4>
    <p className="article__content">{content}</p>
  </div>
);

export default MentionLegal;
